import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M19.995 3.125a16.89 16.89 0 0 1 14.922 24.766l1.265 4.437a3.125 3.125 0 0 1-3.859 3.86l-4.437-1.266a16.875 16.875 0 1 1-7.891-31.797m0 30a13.3 13.3 0 0 0 6.703-1.828c.285-.18.616-.273.953-.266q.263-.003.516.063l4.093 1.172-1.171-4.094a1.86 1.86 0 0 1 .203-1.469 13.14 13.14 0 1 0-11.297 6.422M21.87 20a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0m-8.75 0a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }